import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { BookForm } from "@modules/books/components/BookForm";
import { useBookEditForm } from "./controller";

export const BookEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useBookEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <BookForm />
      </FormProvider>
    </Edit>
  );
});
